module.exports = __webpack_public_path__ + "static/media/contacto.024332de.svg";